<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Deposit Charge</h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="!spinnerShow">
                        <div class="row m-b-sm fees-container"
                             *ngFor="let charge of amenityFees; let index = index; trackBy: trackByFn">
                            <div class="img-checkbox">
                                <span class="col-sm-7">
                                    <textarea class="form-control" name="chargeName{{index}}" [(ngModel)]="charge.name"></textarea>
                                </span>
                                <span class="col-sm-3 fee-input-col">
                                    <span class="fee-input-dollar">$</span>
                                    <input class="form-control" name="chargeName{{index}}" [(ngModel)]="charge.amount">
                                </span>
                                <span class="col-sm-2">
                                    <div class="buttons-row">
                                        <button type="button" (click)="addNewFee(index)">
                                            <i class="fa icon-plus pull-right" title="Add"></i>
                                        </button>
                                        <button type="button" (click)="removeFee(index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </span>
                            </div>
                        </div>

                        <hr>

                        <!--<div class="row m-b-sm" *ngFor="let charge of amenityFees">-->
                            <!--<div *ngIf="charge.amount">-->
                                <!--<div class="col-md-9">-->
                                    <!--<span class="text-capitalize">{{charge.name}}</span>-->
                                <!--</div>-->
                                <!--<div class="col-md-3 fourteenPixelText">-->
                                    <!--{{'$' + charge.amount}}-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->

                        <div class="row m-b-sm sixteen-pixel-bold" *ngIf="getTotalPaymentValue() != '0.00'">
                            <div class="col-md-9">
                                <label>Total Payment Due</label>
                            </div>
                            <div class="col-md-3 mtv-primary-color">
                                {{'$' + getTotalPaymentValue()}}
                            </div>
                        </div>

                        <div class="row m-b-sm sixteen-pixel-bold" *ngIf="getServiceFee() != '0.00'">
                            <div class="col-md-9">
                                <label>Service Fee</label>
                            </div>
                            <div class="col-md-3 mtv-primary-color">
                                {{'$' + getServiceFee()}}
                            </div>
                        </div>

                        <div class="row m-b-sm sixteen-pixel-bold" *ngIf="getFeeTotalWithService() != '0.00'">
                            <div class="col-md-9">
                                <label>Total Charge</label>
                            </div>
                            <div class="col-md-3 mtv-primary-color">
                                {{'$' + getFeeTotalWithService()}}
                            </div>
                        </div>

                        <div class="row text-center space-30">
                            <button class="btn btn-primary submit-btn" type="submit"
                                    [disabled]="disabledSubmit">Save</button>
                        </div>
                    </div>
                    <spinner [spinnerShow]="spinnerShow"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenity-deposit-charge/amenity-deposit-charge.component.html